import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import ProductionTimeNormHistoryItem from "./production-time-norm-history-item.model";

export default class ProductionTimeNormHistoryItemFactory
  implements ObjectBuilderInterface<ProductionTimeNormHistoryItem> {
  public buildFromJSON(data: {
    [key: string]: any;
  }): ProductionTimeNormHistoryItem {
    const value = new ProductionTimeNormHistoryItem(
      data.id,
      data.historyType,
      data.userId,
      data.factory,
      data.product,
      data.days
    );

    (value as any).fCreatedAt = new Date(data.createdAt);

    value.isNew = false;

    return value;
  }
}
